import { createSlice } from '@reduxjs/toolkit';

const getInitialProdState = () => {
    const prodFlag = localStorage.getItem("isProd");
    return prodFlag === undefined || prodFlag === 'true'; // Логика инициализации как у вас
};

const envSlice = createSlice({
    name: 'env',
    initialState: {
        isProd: getInitialProdState(),
    },
    reducers: {
        toggleEnv: (state) => {
            state.isProd = !state.isProd;
            localStorage.setItem("isProd", state.isProd);
        },
        setEnv: (state, action) => {
            state.isProd = action.payload;
            localStorage.setItem("isProd", action.payload);
        }
    },
});

export const { toggleEnv, setEnv } = envSlice.actions;
export default envSlice.reducer;
